/**
 * Embeddings are stored as BLOB columns. `@tauri-apps/plugin-sql` bridges to
 * Rust over JSON, which has no binary type, so both directions go through a
 * plain array of byte values (the documented convention for binding BLOBs
 * with this plugin) rather than a `Uint8Array`/`ArrayBuffer` directly.
 */

/** `Float32Array` → plain byte array, ready to bind as a BLOB parameter. */
export function floatsToBytes(floats: Float32Array): number[] {
  const view = new Uint8Array(floats.buffer, floats.byteOffset, floats.byteLength);
  return Array.from(view);
}

/** BLOB column value → `Float32Array`. Throws on malformed input so callers
 * can skip the row rather than propagate a garbage vector. */
export function bytesToFloats(bytes: number[]): Float32Array {
  if (bytes.length % 4 !== 0) {
    throw new Error(`Embedding byte length (${bytes.length}) isn't a multiple of 4.`);
  }
  const u8 = Uint8Array.from(bytes);
  return new Float32Array(u8.buffer, u8.byteOffset, u8.byteLength / 4);
}
